import React, { ReactNode } from 'react'
import { Box, Button } from '@mui/material'
import { doUpdate } from '../../tree/nodeUpdates/utility'
import { ConfirmCommitButton } from 'shared/ui'
import { UpdatesView } from './UpdatesView'
import { GoogleLoginButton } from 'infrastructure/googleDrive'
import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { allSwapUpdatesAtom, presentationSwapTreeAtom } from './atoms'
import { useGetTreeById } from 'shared/hooks/trees/hooks'

function HeaderStuff() {
  return (
    <Box padding="20px">
      <Box>
        <strong>Presentation URL Swap</strong>
      </Box>
      <Box>
        This tool is to be used for when you want to swap out the url used in
        presentations. You first need to connect your Google Account to get
        access to the presentations. Once connected with a tree this tool will
        pull the IM presentations for the correct grade. The file name and url
        is used to locate the presentation node in which the url should be
        swapped. Nodes that already contains the new url will be displayed in
        the <strong>Completed</strong> section.
      </Box>
    </Box>
  )
}

export function TreeUrlSwap({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree, resetTree } = useGetTreeById({ treeId, versionId })
  useSetAtom(presentationSwapTreeAtom)(tree)
  const updatesData = useAtomValue(allSwapUpdatesAtom)

  const callDoUpdateOnAllUpdatesData = async () => {
    if (!updatesData) return
    await doUpdate(...updatesData.updates)
    resetTree?.()
  }

  return (
    <Box>
      <HeaderStuff />
      <GoogleLoginButton
        hideWhenLoggedIn={true}
        ParentComponent={({ children }: { children?: ReactNode }) => {
          return <Box>To retrieve presentation files you must {children}</Box>
        }}
      />
      <Box>
        <Button onClick={resetTree}>Refetch</Button>
        <ConfirmCommitButton
          disabled={!updatesData?.updates.length}
          onClick={callDoUpdateOnAllUpdatesData}
        >
          Update All
        </ConfirmCommitButton>
      </Box>
      {updatesData && <UpdatesView />}
    </Box>
  )
}
